import { useState } from 'react';
import { SavedConnectionsList } from '../../../connections/components/SavedConnectionsList';
import { NewConnectionPopup } from '../../../connections/components/NewConnectionPopup';
import { useConnectionStore } from '../../../connections/store/connectionStore';
import type { Connection, SaveConnectionOptions } from '../../../../types/electron';

interface ConnectionsSettingsTabProps {
  onAddNew: () => void;
}

export function ConnectionsSettingsTab({ onAddNew }: ConnectionsSettingsTabProps) {
  const [editingConnection, setEditingConnection] = useState<Connection | null>(null);
  const { updateConnection, deleteConnection } = useConnectionStore();

  const handleEdit = (connection: Connection) => {
    setEditingConnection(connection);
  };

  const handleSaveEdit = async (connection: Connection, options: SaveConnectionOptions): Promise<boolean> => {
    const success = await updateConnection(connection, options);
    if (success) {
      setEditingConnection(null);
    }
    return success;
  };

  const handleDelete = async (connectionId: string): Promise<boolean> => {
    const success = await deleteConnection(connectionId);
    if (success) {
      setEditingConnection(null);
    }
    return success;
  };

  const handleCancelEdit = () => {
    setEditingConnection(null);
  };

  return (
    <>
      <SavedConnectionsList onAddNew={onAddNew} showAddButton={true} onEdit={handleEdit} />

      {editingConnection && (
        <NewConnectionPopup
          onSave={handleSaveEdit}
          onCancel={handleCancelEdit}
          onDelete={handleDelete}
          editConnection={editingConnection}
        />
      )}
    </>
  );
}
